import type { PublicStore } from "core/store/store-utils";
import type { JsonUserDocumentPreference } from "referrals/js/api/user-document-preferences.api";
import type { DocumentDownloadPreference } from "referrals/js/enum/document-download-preference";
import { createLoadingPromise } from "core/store/store-utils";
import { defineStore } from "pinia";
import { getUserDocumentPreference, updateUserDocumentPreference as updateUserDocumentPreferenceApi } from "referrals/js/api/user-document-preferences.api";
import { ref } from "vue";

export const useUserDocumentPreferenceStore = defineStore("feature/referrals/user-document-preferences", () => {
  const userDocumentPreference = ref<JsonUserDocumentPreference | undefined>(undefined);

  async function fetchUserDocumentPreference() {
    userDocumentPreference.value = await getUserDocumentPreference();
  }

  async function updateUserDocumentPreference(documentDownloadPreference: DocumentDownloadPreference) {
    await updateUserDocumentPreferenceApi({ documentDownloadPreference });
    await fetchUserDocumentPreference();
  }

  const loadingPromise = createLoadingPromise(fetchUserDocumentPreference);

  return {
    isReady: loadingPromise.isReady,
    userDocumentPreference,
    updateUserDocumentPreference,
  };
});

type UserDocumentPreferencePublicStore = PublicStore<typeof useUserDocumentPreferenceStore, "isReady" | "userDocumentPreference">;
export function useUserDocumentPreferencePublicStore(): UserDocumentPreferencePublicStore {
  return useUserDocumentPreferenceStore();
}
